import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { DropdownMenu, DropdownItem, DropdownToggle, UncontrolledDropdown  } from 'reactstrap';
import * as Accounts from '../store/Accounts';
import * as Localizer from '../store/Localization';
import * as paths from '../data/Paths';
import * as Records from '../store/Records';
import './NavMenu.css';

class NavMenuSignedIn extends React.Component {
    componentDidMount() {
        this.props.localizerDispatch.getAllStrings();
    }

    componentDidUpdate() {
        this.props.localizerDispatch.getAllStrings();
    }

    handleSignOut() {
        (async () => {
            await this.props.accountsDispatch.signOut();
            await this.props.recordsDispatch.resetAll();
        })().then(() => {
            this.props.history.push(paths.home);
        });
    }

    renderAdministratorItems() {
        const localizer = this.props.localizerState;
        return (
            <React.Fragment>
                <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>{localizer.create}</DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem tag={Link} to={{pathname: paths.createAccount, state: { create: true }}}>{localizer.account}</DropdownItem>
                        <DropdownItem tag={Link} to={paths.createSponsor}>{localizer.sponsor}</DropdownItem>
                        <DropdownItem tag={Link} to={paths.createStudy}>{localizer.study}</DropdownItem>
                        <DropdownItem tag={Link} to={paths.createSite}>{localizer.site}</DropdownItem>
                        <DropdownItem tag={Link} to={paths.createPatient}>{localizer.patient}</DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>Manage</DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem tag={Link} to={paths.manageAccounts}>Accounts</DropdownItem>
                        <DropdownItem tag={Link} to={paths.manageSponsors}>Sponsors</DropdownItem>
                        <DropdownItem tag={Link} to={paths.manageStudies}>Studies</DropdownItem>
                        <DropdownItem tag={Link} to={paths.manageSites}>Sites</DropdownItem>
                        <DropdownItem tag={Link} to={paths.managePatients}>Patients</DropdownItem>
                        <DropdownItem tag={Link} to={paths.billing}> Billing </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            </React.Fragment>
        );
    }

    render() {
        const renderAdministrator = (this.props.accountsState.authenticatedAccount.role === Accounts.accountRoles.Administrator || Accounts.accountRoles.Pm);
        const userName = this.props.accountsState.authenticatedAccount.userName;

        return (
            <ul className="navbar-nav flex-grow" >
                {renderAdministrator && this.renderAdministratorItems()}
                <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav caret>{userName}</DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem tag={Link} to={{ pathname: paths.account, state: { editing: false, userName: userName } }}>Account</DropdownItem>
                        <DropdownItem tag={Link} to={paths.settings} > Settings </DropdownItem>
                        <DropdownItem tag={Link} to={paths.home} onClick={this.handleSignOut.bind(this)}>{this.props.localizerState.signOut}</DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem tag={Link} to={paths.about}>About</DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            </ul>
        );
    }
}

export default withRouter(connect(
    state => ({
        accountsState: state.accounts,
        localizerState: state.localizer
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        localizerDispatch: bindActionCreators(Localizer.actionCreators, dispatch),
        recordsDispatch: bindActionCreators(Records.actionCreators, dispatch)
    })
)(NavMenuSignedIn));



// WEBPACK FOOTER //
// ./src/components/NavMenuSignedIn.js